export const protocolsReducer = (state = {loading: false, resultprotocol: null, protocols: [], protocol: null, total: 0} , action) => {
    switch (action.type) {
        case 'PROTOCOL_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                protocols: action.payload.protocols,
                total: action.payload.total
            }
        case 'PROTOCOL_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                protocol: action.payload.protocol
            }
        case 'PROTOCOL_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultprotocol: action.payload.message,
                protocol: action.payload.protocol,
                protocols: [...state.protocols, action.payload.protocol],
            }
        case 'PROTOCOL_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultprotocol: action.payload.message
            }
        case 'PROTOCOL_EDIT_SUCCESS':
            if(action.payload.protocol){
                return {
                    ...state,
                    loading: false,
                    resultprotocol: action.payload.message,
                    protocol: action.payload.protocol,
                    protocols: state.protocols.map(protocol => protocol._id === action.payload.protocol._id ? action.payload.protocol : protocol),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultprotocol: action.payload
                }
            }
        case 'PROTOCOL_RESET_RESULT':
            return {
                ...state,
                resultprotocol: null
            }
        case 'PROTOCOL_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PROTOCOL_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
